/**
 * Created by kldavis on 2/23/17.
 */
var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.DynamicScriptLoaderAsyncRun = new Class({
    Extends: OCS.Classes.DynamicScriptLoaderRun,
    load_scripts: function (urls) {
        // Load all the scripts at once.
        urls.forEach(function (url) {
            this.load_single_script(url);
        }.bind(this));
    },
    continue_load: function () {
        // All the scripts will load all at once
        if (this.options.loaded.length == this.options.load.length) {
            this.complete_run();
        }
    }
});